import { createContext, type Context } from 'react';

type MenuGroupContextProps = {
  /**
   * Called by a nested `Menu.Label` to offer itself as the accessible name of
   * the group. Returns a cleanup that withdraws the offer.
   */
  registerLabel: (labelId: string) => () => void;
};

/** @internal */
export const MenuGroupContext: Context<MenuGroupContextProps | undefined> =
  createContext<MenuGroupContextProps | undefined>(undefined);
